import request from '@/utils/request'
const api_name = 'housingstatistics'
export default{
    getHousingStatistics(){
        return request({
            url:`/${api_name}/gethousingstatistics`,
            method:'get'
        })
    }
}







